<template>
  <vs-textarea
    :value="value"
    @input="handleInput"
    rows="4"
    class="mb-3"
    v-if="editable"
    :aria-label="accessibleLabel"
  />
  <p class="my-5" v-else>{{ value ? value : 'N/A' }}</p>
</template>

<script>
export default {
  // See TextBlock: pass the question text as `label` where it is known.
  props: ['value', 'editable', 'label'],
  computed: {
    // With no explicit label, utils/a11yDom.js names the control from the question text
    // that precedes it; the generic fallback only applies when there is none.
    accessibleLabel() {
      return this.$props.label || null;
    },
  },
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
    };
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>
